import { Component, Input, OnInit } from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';
import localeData from 'i18n-iso-countries/langs/en.json';
import { SecurityIndex } from 'src/app/shared/models/company/security-index.model';

@Component({
  selector: 'rms-security-index-search-item',
  standalone: false,
  templateUrl: './security-index-search-item.component.html',
  styleUrl: './security-index-search-item.component.scss'
})
export class SecurityIndexSearchItemComponent implements OnInit {

  @Input() item: SecurityIndex

    ngOnInit(): void {
      i18nIsoCountries.registerLocale(localeData);
    }


    public countryIsoCodeToName(isoCode: string) {
        const countryName = i18nIsoCountries.getName(isoCode, 'en', {select: 'alias'});
        return  countryName ? `(${countryName})` : '';
    }

}
